import { createClient } from '@sanity/client'

const sanityClient = createClient({
  projectId: 'swkpbxax',
  dataset: 'production',
  apiVersion: '2025-08-25',
  useCdn: true,
})

export default sanityClient
